import { $api } from "../../../../services/request.config";

import IndividualCoefficientsService from "../../../../../frontend.services/LeaderRequests/IndividualCoefficientsService";

export const getAvailableEventsThunkAction = () => async () => {
    try {
        const response = await $api("v1/managers/requests/individual-coefficients/available-events");
        return { ok: true, data: response.data };
    } catch (error) {
        return { ok: false, error: IndividualCoefficientsService.classifyError(error) };
    }
};